import type { IconName } from "@once-ui-system/core";

// Everything the shell shows that is about the product. The sidebar, breadcrumb and
// command palette read it; `permission` hides entries the signed-in user cannot use.

export const app = {
  name: "ML Ark",
  description: "AI contact-center console: voicebots, campaigns and live agents",
};

export type NavLink = {
  href: string;
  label: string;
  icon: IconName;
  /** Shown when the user holds this permission globally or on any campaign. */
  permission?: string;
};
export type NavSection = { label: string; items: NavLink[] };

export const nav: NavSection[] = [
  {
    label: "Platform",
    items: [
      { href: "/dashboard", label: "Overview", icon: "grid" },
      { href: "/campaigns", label: "Campaigns", icon: "flag", permission: "campaign:read" },
      { href: "/users", label: "Users", icon: "people", permission: "user:read" },
    ],
  },
  {
    label: "Governance",
    items: [
      { href: "/audit", label: "Audit log", icon: "document", permission: "audit:read" },
      { href: "/roles", label: "Roles & permissions", icon: "security", permission: "role:read" },
    ],
  },
  {
    label: "Settings",
    items: [
      { href: "/settings/organization", label: "Organization", icon: "organization", permission: "org:update" },
      { href: "/settings/sso", label: "Single sign-on", icon: "lock", permission: "org:sso_manage" },
      { href: "/settings/providers", label: "AI providers", icon: "sparkle", permission: "provider:manage" },
      { href: "/settings/profile", label: "Profile", icon: "person" },
      { href: "/settings/security", label: "Sessions", icon: "computer" },
    ],
  },
];

/** Every link in `nav`, in order. */
export const navLinks: NavLink[] = nav.flatMap((section) => section.items);
